function r(e) {
  switch (e) {
    case "small":
      return "400px";
    case "large":
      return "800px";
    default:
      return "600px";
  }
}
export { r as sizeModal };